import script from "./VTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./VTime.vue?vue&type=script&lang=ts&setup=true"

import "./VTime.vue?vue&type=style&index=0&id=731a1c68&lang=sass"

const __exports__ = script;

export default __exports__